import type { QuoteLineItemView } from "@/services/quoteLineItems";
import type { QuoteLineDraft } from "@/components/features/notarial-requests/quote-submission-fields";

/**
 * An existing bid's lines, back as editable drafts.
 *
 * A UR LINE MUST COME BACK AS UR. `amountMinor` on such a line is the peso
 * figure it was CONVERTED to at submission; seeding that would silently
 * re-price the bid in pesos and drop the index link, so an untouched "save"
 * would change the quote. The stored `urUnits` and `urType` are what the
 * professional actually typed, and they are what comes back.
 *
 * Mirrors mobile's prefill (bid.tsx), which is where this behaviour was
 * settled first.
 */
export function quoteLineDraftsFromItems(
  lineItems: QuoteLineItemView[] | null,
): QuoteLineDraft[] {
  if (lineItems == null || lineItems.length === 0) return [createQuoteLineDraft()];
  return lineItems.map((item) => {
    const isUr = item.urType != null && item.urUnits != null;
    return {
      key: crypto.randomUUID(),
      description: item.description,
      kind: item.kind,
      amount: isUr ? String(item.urUnits) : formatAmountFieldText(item.amountMinor),
      unit: isUr && item.urType != null ? item.urType : "UYU",
    };
  });
}

/**
 * Minor units back into the text the field expects: a comma decimal, which is
 * how prices are written here and what parseUyAmount reads back.
 */
function formatAmountFieldText(amountMinor: number): string {
  return (amountMinor / 100).toFixed(2).replace(".", ",");
}

export function createQuoteLineDraft(): QuoteLineDraft {
  return {
    key: crypto.randomUUID(),
    description: "",
    kind: "honorarios",
    amount: "",
    unit: "UYU",
  };
}
